import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const MainContainer = styled(Box)`
  background-color: #2b2b33;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

export const BoxContainer = styled(Box)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: absolute;
  z-index: 2;
  pointer-events: none;
`;

export const BoxText = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  text-align: center;
  flex-direction: column;

  ::selection {
    background-color: #2b2b33;
    color: #f3f2f9;
  }

  animation: fadeInFromTop 0.5s ease-in-out;
  animation-fill-mode: backwards;

  @keyframes fadeInFromTop {
    0% {
      transform: translateY(-10%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 540px) and (max-height: 720px) {
    height: 100%;
    width: 100%;
    margin: 0px 24px;
  }

  @media (max-width: 430px) and (max-height: 932px),
    @media (max-width: 412px) and (max-height: 915px),
    @media (max-width: 412px) and (max-height: 914px) {
    height: 100%;
    width: 100%;
    margin: 0px 24px;
  }
`;

export const TitleName = styled(Typography)<{ isLightMode: boolean }>`
  && {
    font-weight: 600;
    display: flex;
    gap: 20px;
    text-transform: uppercase;
    letter-spacing: 0.15rem;
    text-shadow: 2px 0 #aab2d1, 0 2px #aab2d1, 2px 0 #aab2d1, 0 -2px #aab2d1,
      4px 4px 8px rgba(0, 0, 0, 0.5);
    text-shadow: ${(props) =>
      props.isLightMode &&
      "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    color: #2b2b33;
    color: ${(props) => props.isLightMode && "#f3f2f9"};
    font-family: "Lilita One", sans-serif;
    pointer-events: all;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 2rem;
      display: flex;
      flex-direction: column;
      gap: 0px;
      text-shadow: 1px 0 #aab2d1, 0 1px #aab2d1, 1px 0 #aab2d1, 0 -1px #aab2d1,
        4px 4px 8px rgba(0, 0, 0, 0.5);
      text-shadow: ${(props) =>
        props.isLightMode &&
        "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0px;
      text-shadow: 1px 0 #aab2d1, 0 1px #aab2d1, 1px 0 #aab2d1, 0 -1px #aab2d1,
        4px 4px 8px rgba(0, 0, 0, 0.5);
      text-shadow: ${(props) =>
        props.isLightMode &&
        "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    }
  }
`;

export const TitleNameActive = styled(Typography)<{ isLightMode: boolean }>`
  && {
    font-family: "Lilita One", sans-serif;
    color: #aab2d1;
    color: ${(props) => props.isLightMode && "#606887"};
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    letter-spacing: 0.15rem;
    pointer-events: all;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 2rem;
      letter-spacing: 0.3rem;
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1.5rem;
      letter-spacing: 0.3rem;
    }
  }
`;

export const TitleNickName = styled(Typography)<{ isLightMode: boolean }>`
  && {
    font-weight: 600;
    display: flex;
    gap: 20px;
    text-transform: uppercase;
    letter-spacing: 0.15rem;
    text-shadow: 2px 0 #aab2d1, 0 2px #aab2d1, 2px 0 #aab2d1, 0 -2px #aab2d1,
      4px 4px 8px rgba(0, 0, 0, 0.5);
    text-shadow: ${(props) =>
      props.isLightMode &&
      "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    color: #2b2b33;
    color: ${(props) => props.isLightMode && "#f3f2f9"};
    font-family: "Lilita One", sans-serif;
    pointer-events: all;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 2rem;
      display: flex;
      flex-direction: column;
      gap: 0px;
      text-shadow: 1px 0 #aab2d1, 0 1px #aab2d1, 1px 0 #aab2d1, 0 -1px #aab2d1,
        4px 4px 8px rgba(0, 0, 0, 0.5);
      text-shadow: ${(props) =>
        props.isLightMode &&
        "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0px;
      text-shadow: 1px 0 #aab2d1, 0 1px #aab2d1, 1px 0 #aab2d1, 0 -1px #aab2d1,
        4px 4px 8px rgba(0, 0, 0, 0.5);
      text-shadow: ${(props) =>
        props.isLightMode &&
        "-1px -1px 0 #606887, 1px -1px 0 #606887, -1px 1px 0 #606887, 1px 1px 0 #606887, 4px 4px 8px rgba(0, 0, 0, 0.5)"};
    }
  }
`;

export const TitleNickNameActive = styled(Typography)<{ isLightMode: boolean }>`
  && {
    font-family: "Lilita One", sans-serif;
    color: #aab2d1;
    color: ${(props) => props.isLightMode && "#606887"};
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    letter-spacing: 0.15rem;
    pointer-events: all;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 2rem;
      letter-spacing: 0.3rem;
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1.5rem;
      letter-spacing: 0.3rem;
    }
  }
`;

export const BoxRoles = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  text-align: center;
  flex-direction: column;
`;

export const TextRoles = styled(Typography)<{ isLightMode: boolean }>`
  && {
    font-size: 1.5rem;
    color: #f3f2f9;
    color: ${(props) => props.isLightMode && "#606887"};
    font-weight: 600;
    letter-spacing: -0.015rem;
    font-family: "Montserrat", sans-serif;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: all;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 1rem;
      line-height: 1.3;
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1rem;
      line-height: 1.3;
    }
  }
`;

export const BoxLinks = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  text-align: center;
  flex-direction: row;
  padding: 16px;
  gap: 20px;

  @media (max-width: 430px) and (max-height: 932px),
    @media (max-width: 412px) and (max-height: 915px),
    @media (max-width: 412px) and (max-height: 914px) {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
`;

export const TextLinks = styled.a<{ isLightMode: boolean; disabled: boolean }>`
  && {
    font-size: 1.25rem;
    font-variation-settings: "wght" 500, "wdth" 125;
    text-transform: lowercase;
    text-decoration: none;
    color: #f3f2f9;
    color: ${(props) => props.isLightMode && "#606887"};
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    gap: 8px;
    align-items: center;
    position: relative;
    pointer-events: all;
    font-family: "Montserrat", sans-serif;
    line-height: 1.168;
    cursor: pointer;

    ::selection {
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#78ffd1"};
      color: #aab2d1;
      color: ${(props) => props.isLightMode && "#606887"};
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    }

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -8px;
      width: 0;
      height: 4px;
      background-color: #f3f2f9;
      background-color: ${(props) => props.isLightMode && "#606887"};
      transition: width 0.3s ease-in-out;
    }

    :hover {
      &::after {
        width: 100%;
        left: 0;
        transform: none;
      }
    }

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 1rem;
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1rem;
    }

    ${({ disabled }) =>
      disabled &&
      `
        filter: opacity(0.3);
      `};
  }
`;

export const ArrowRigthIcon = styled(ArrowForwardIcon)<{
  isLightMode: boolean;
}>`
  && {
    color: #f3f2f9;
    color: ${(props) => props.isLightMode && "#606887"};

    @media (max-width: 540px) and (max-height: 720px) {
      font-size: 1rem;
    }

    @media (max-width: 430px) and (max-height: 932px),
      @media (max-width: 412px) and (max-height: 915px),
      @media (max-width: 412px) and (max-height: 914px) {
      font-size: 1rem;
    }
  }
`;
